import React from "react";
import IconAsButton from "src/components/IconAsButton";
import { ReactComponent as NextIcon } from "./next.svg";
import { ReactComponent as PreviousIcon } from "./previous.svg";

export default function DirectionButton({ type, ...rest }) {
  return (
    <IconAsButton
      size="24px"
      icon={type === "next" ? NextIcon : PreviousIcon}
      {...rest}
    />
  );
}
